import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.113 1.427a9 9 0 0 0-1.446-.127A8.63 8.63 0 0 0 8 2.667a8.63 8.63 0 0 0-4.667-1.334 9 9 0 0 0-1.446.127.67.67 0 0 0-.554.667v8a.667.667 0 0 0 .78.666 7.27 7.27 0 0 1 5.5 1.274l.08.046h.074a.6.6 0 0 0 .466 0h.074l.08-.046a7.27 7.27 0 0 1 5.5-1.347.667.667 0 0 0 .78-.667v-8a.67.67 0 0 0-.554-.626m-6.78 8.86a8.6 8.6 0 0 0-4-.987h-.666V2.633q.333-.018.666 0a7.24 7.24 0 0 1 4 1.2zm6-.96h-.666a8.6 8.6 0 0 0-4 .986v-6.48a7.24 7.24 0 0 1 4-1.2q.333-.018.666 0zm.78 2.766a9 9 0 0 0-1.446-.126A8.63 8.63 0 0 0 8 13.333a8.63 8.63 0 0 0-4.667-1.366 9 9 0 0 0-1.446.126.666.666 0 0 0-.554.767.667.667 0 0 0 .78.527 7.27 7.27 0 0 1 5.5 1.273.67.67 0 0 0 .774 0 7.27 7.27 0 0 1 5.5-1.273.667.667 0 0 0 .78-.527.667.667 0 0 0-.554-.767"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })